import React from 'react';
import DecimalHelpBlock from '../DecimalHelpBlock';
import Utils from '../Utils';
import {isNullOrUndefined} from '../utils/general';
import {commaDecimalToFloat} from '../utils/number';

const BudgetFields = ({budget, vat, budgetVat, onStateUpdate}) => {
    const handleBudgetChange = (e) => {
        const value = Utils.handleDecimals(e.target.value);
        const budget = parseFloat(e.target.value.replace(',', '.'));
        // Calculate guarantee_amount
        const guaranteeAmount = Utils.calculateGuaranteeAmount(budget);
        // Calculate budget_vat
        const budgetVat = Utils.calculateAmountVATFromAmount(vat, budget);

        onStateUpdate({
            budget: value,
            budget_vat: budgetVat,
            guarantee_amount: guaranteeAmount,
        });
    }

    const handleVATChange = (e) => {
        const value = Utils.handleDecimals(e.target.value);
        // Calculate budget_vat
        const vat = parseFloat(e.target.value.replace(',', '.'));
        const budgetVat = Utils.calculateAmountVATFromVAT(vat, budget);

        onStateUpdate({
            vat: value,
            budget_vat: budgetVat,
        });
    }

    let budgetVatDisplay = commaDecimalToFloat(budgetVat);

    budgetVatDisplay = budgetVatDisplay === null
        ? ''
        : budgetVatDisplay.toFixed(2).replace('.', ',');

    return (
        <div className="form-group">
            <label htmlFor="budget"
                   className="control-label col-md-4">{window.__js_contracts.budget}</label>
            <div className="col-md-8">
                <div className="table-responsive">
                    <table className="table table-hover table-striped table-bordered"
                           style={{marginBottom: 0}}>
                        <thead>
                        <tr>
                            <th>{window.__js_contracts.budget_without_vat}*</th>
                            <th>{window.__js_contracts.vat_rate}</th>
                            <th>{window.__js_contracts.final_value}</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td>
                                <input type="text"
                                       id="budget_comma"
                                       name="budget_comma"
                                       value={isNullOrUndefined(budget) ? '' : budget}
                                       className="form-control"
                                       onChange={handleBudgetChange}/>
                            </td>
                            <td>
                                <input type="text"
                                       id="vat_comma"
                                       name="vat_comma"
                                       value={isNullOrUndefined(vat) ? '' : vat}
                                       className="form-control"
                                       onChange={handleVATChange}/>
                            </td>
                            <td>
                                <input type="text"
                                       disabled={true}
                                       id="budget_vat"
                                       name="budget_vat"
                                       value={isNullOrUndefined(budgetVat) ? '' : budgetVatDisplay}
                                       className="form-control"/>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <DecimalHelpBlock/>
            </div>
        </div>
    );
}

export default BudgetFields;